/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import proptypes from 'prop-types';
const { shape, bool, number, object, string } = proptypes;
import { useStore, useConfigService } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { formatDate, formatInventory, showTodayOrTomorrow } from '../../../helper/utils';
import { getDefaultStoreHours, showBopisDate } from '../../../helper/timeZoneUtils';
import { IDS } from '../../../../automationTestIds';

const DefaultBOPIS = ({
  localStoreLocation, pickupStoreHours = null, isCartTiles = false, fallbackMode = false,
  configuratorHideQuantity = false, deliveryTimeline = null, fulfillment = {}, bopisBossFFAEnabled = false
}) => {
  const isBopisBossFFAEnabled = useConfigService('fs:bopisBossFFAEnabled') || bopisBossFFAEnabled;
  let { storeHours } = useStore();
  if (!storeHours) {
    storeHours = getDefaultStoreHours();
  }
  const isInStock = localStoreLocation?.inventory?.isInStock || '';
  const quantity = localStoreLocation?.inventory?.quantity;
  const formattedInventoryQty = formatInventory(quantity);
  const pickupStoreHoursWithTZ = isCartTiles ? pickupStoreHours
    : { ...storeHours, ...pickupStoreHours };
  const isZeroInStock = isCartTiles && formattedInventoryQty <= 0;
  const isCartResilency = isCartTiles && (deliveryTimeline === null || deliveryTimeline === 'null')
    && localStoreLocation?.storeHours === null;

  const renderBopisTimeline = () => (deliveryTimeline ? (
    showTodayOrTomorrow(
      fulfillment?.deliveryDates?.endDate,
      true,
      deliveryTimeline,
      formatDate(fulfillment?.deliveryDates?.endDate)
    )
  ) : (
    showBopisDate(pickupStoreHoursWithTZ)
  ));

  const isBOPISFallbackEnabled = isBopisBossFFAEnabled && fallbackMode;

  const displayFFMRowDetails = () => {
    if (!isBOPISFallbackEnabled && isInStock) {
      return (
        <>
          <Typography variant="body-base" weight="bold" component="div">
            <div
              className="sui-font-bold sui-min-h-[24px] sui-pb-1"
              data-testid="pickupTimeline"
              data-automation-id={IDS.ETA.pickupETA}
            >
              {isCartResilency ? <span>{"\u00A0"}</span> : renderBopisTimeline()}
            </div>
          </Typography>
          <Typography variant="body-base" component="div">
            <div
              data-testid="fulfillment-qty-row"
              className="sui-min-h-[24px]"
              data-automation-id={IDS.QTY.pickupQty}
            >
              {(!isBOPISFallbackEnabled && !configuratorHideQuantity && !fulfillment?.ffaFallbackMode) ? (
                <>
                  <span className="sui-text-success">{formattedInventoryQty}</span> in stock
                </>
              ) : (
                <span data-testid="empty-qty-row">{"\u00A0"}</span>
              )}
            </div>
          </Typography>
        </>
      );
    }
    return (
      <>
        <div
          className="sui-font-bold sui-min-h-[24px] sui-pb-1"
          data-testid="pickupTimeline"
          data-automation-id={IDS.ETA.pickupETA}
        >{"\u00A0"}
        </div>
        <div
          data-testid="fulfillment-qty-row"
          className="sui-min-h-[24px]"
          data-automation-id={IDS.QTY.pickupQty}
        >{"\u00A0"}
        </div>
      </>
    );
  };

  return (
    <div>
      <TileHead title="Pickup" automationId={IDS.LABEL.pickupLabel} />
      <div className="">
        <div data-testid="ffm-details-row" className="sui-pt-2">
          {displayFFMRowDetails()}
        </div>
        <TileFooter>
          <span className="sui-font-bold sui-text-success">FREE</span>
        </TileFooter>

      </div>
    </div>

  );
};

DefaultBOPIS.propTypes = {
  localStoreLocation: shape({
    isAnchor: bool,
    inventory: shape({
      quantity: number,
      isInStock: bool,
      isLimitedQuantity: bool,
      isBackordered: bool
    })
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  pickupStoreHours: object,
  isCartTiles: bool,
  fallbackMode: bool,
  configuratorHideQuantity: bool,
  deliveryTimeline: string,
  // eslint-disable-next-line react/forbid-prop-types
  fulfillment: object,
  bopisBossFFAEnabled: bool
};

export { DefaultBOPIS };
